import React from 'react';
import Header from '../Header/Header';
import TitleBar from '../TitleBar/TitleBar';
import Aside from '../Aside/Aside';
import Card from '../Card/Card';
import * as s from './layout.styles';

const Layout = ({
  children,
  title,
  summary,
  onMenuSelect,
  showFaq = true,
  menuSelect,
  onlyGST,
  sendTrackingDataToSdk,
}) => {
  return (
    <React.Fragment>
      <Header />
      <TitleBar />
      <main>
        <Aside
          onMenuSelect={onMenuSelect}
          menuSelectPage={menuSelect}
          onlyGST={onlyGST}
          sendTrackingDataToSdk={sendTrackingDataToSdk}
        />
        <div className="content">
          {/* <SignUpTile /> */}
          <Card>
            {/* <s.GstBlinker className="gstBlinker">
              <s.GstBlinkerIconContainer>
                <img
                  src="https://assets-gos3.goibibo.com/gstBlinkerIcon-1751885947.png"
                  style={{width: '24px', height: '24px'}}
                ></img>
              </s.GstBlinkerIconContainer>
              <div style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
                <s.GstBlinkerText> Final Reminder:</s.GstBlinkerText>

                <s.GstBlinkerSubText>
                  {' '}
                  Deadline to claim ITC against <b> FY 2024-25 </b>for all pending invoices and
                  amendments via myPartner Dashboard is<b> 10th October 2025. </b> Invoices
                  submitted after this date won't be accepted for ITC by myPartner.
                </s.GstBlinkerSubText>
              </div>
            </s.GstBlinker> */}
            {title && (
              <s.TitleContainer>
                <s.Title>{title}</s.Title>
                {showFaq && (
                  <a
                    onClick={e => {
                      window.open(
                        'https://promos.makemytrip.com/mypartner-commission-model-150523.html',
                        '_blank',
                      );
                      sendTrackingDataToSdk?.(
                        {
                          event_detail: {
                            event_name: 'click',
                            event_type: 'user_action',
                            event_value: 'FAQ CTA Clicked',
                          },
                        },
                        'GST_INVOICE_REPORT',
                      );
                    }}
                  >
                    FAQs
                  </a>
                )}
              </s.TitleContainer>
            )}
            {summary && <s.Summary>{summary}</s.Summary>}
            {children}
          </Card>
        </div>
      </main>
    </React.Fragment>
  );
};

export default Layout;
